import { create } from 'zustand';
import type { AuthState } from '../types/auth.types';
import appInsightsService from '../../../services/appInsights/appInsights.service';

export const useAuthStore = create<AuthState>()(
  (set) => ({
    user: null,
    accessToken: null,
    sessionId: null,
    isAuthenticated: false,

    setAuth: (user, accessToken, sessionId) => {
      try {
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem('sessionId', sessionId);
        localStorage.setItem('authUser', JSON.stringify(user));
      } catch (e) {
        // QuotaExceededError — storage full. Clear stale data and retry once.
        console.warn('localStorage full, clearing stale data and retrying', e);
        try {
          localStorage.removeItem('auth-storage');
          localStorage.removeItem('invoice-filter-storage');
          localStorage.setItem('accessToken', accessToken);
          localStorage.setItem('sessionId', sessionId);
          localStorage.setItem('authUser', JSON.stringify(user));
        } catch {
          // Still failing — continue without persistence.
          // Zustand state will keep the session alive for this tab.
          console.error('localStorage completely unavailable');
        }
      }
      try { appInsightsService.setAuthenticatedUser(user.id); } catch { /* telemetry must never break login */ }
      set({ user, accessToken, sessionId, isAuthenticated: true });
    },

    clearAuth: () => {
      localStorage.removeItem('accessToken');
      localStorage.removeItem('sessionId');
      localStorage.removeItem('selectedCompanyId');
      localStorage.removeItem('authUser');
      localStorage.removeItem('auth-storage'); // Limpiar legacy key si existe
      localStorage.removeItem('invoice-filter-storage');
      appInsightsService.clearAuthenticatedUser();
      set({ user: null, accessToken: null, sessionId: null, isAuthenticated: false });
    },

    updateUser: (userData) =>
      set((state) => {
        const updatedUser = state.user ? { ...state.user, ...userData } : null;
        if (updatedUser) {
          localStorage.setItem('authUser', JSON.stringify(updatedUser));
        }
        return {
          user: updatedUser,
        };
      }),
  })
);
